module.exports = __webpack_public_path__ + "media/images/PB_Digiteer_MobileBanner-24d006b825482f7bd0c7379296631787.jpg";